export default __webpack_public_path__ + "static/heroimg-b23b2a5de51d11cf3ce5abbb401a0a54.png";